module.exports = __webpack_public_path__ + "img/temperature.bca90fa6.svg";